import { ReactNode } from 'react'
import { cn } from '../lib/cn'

interface DocumentPageProps {
  children: ReactNode
  className?: string
}

/**
 * Contenedor del documento.
 *
 * A propósito **no** declara tamaño de hoja ni márgenes: de la geometría de
 * página se encarga el preset que la API le pasa al renderer (`format` +
 * `margin` en `@piramid/internals/constants/pdf-presets`). Si el componente
 * también fijara 210x297mm y padding, se aplicarían dos veces y Chromium
 * terminaría escalando el contenido para meterlo en el área imprimible.
 *
 * Para verlo como hoja en el navegador, el preview lo envuelve en un marco del
 * ancho del área de contenido.
 *
 * `data-document-ready` es la señal que espera la Lambda antes de imprimir
 * (`DOCUMENT_READY_SELECTOR`). Como el árbol se renderiza en el servidor, el
 * atributo ya viene en el HTML inicial.
 */
export const DocumentPage = ({ children, className }: DocumentPageProps) => (
  <article
    data-document-ready='true'
    className={cn(
      'w-full bg-white text-[10pt] leading-snug text-zinc-900',
      className,
    )}
  >
    {children}
  </article>
)
